// extracted by mini-css-extract-plugin
export default {"htmlContent":"HtmlContent_htmlContent__flIyG"};